import { NextPage } from "next";
import { useIntl } from "react-intl";
import HeroBlock, {
  HeroBlockProps,
} from "@/components/common/heroBlock/HeroBlock";
import Layout from "@/components/layout/Layout";
import { PageProps } from "@/pages/_app";
import { routes } from "@/routes/routes";
import { Article, ArticleProps } from "@/components/common/article/Article";
import { Section } from "@/components/common/section/Section";
import ReviewsBlock, {
  RentACarReview,
  ReviewsConst,
} from "@/components/common/reviewsBlockV1/ReviewsBlock";
import { Banner, BannerProps } from "@/components/common/banner/Banner";
import { AllReviews, Reviews } from "./allReviews/AllReviews";
import styles from "./AvisRentACar.module.scss";

export type AvisRentACarProps = PageProps & {
  heroBlock: HeroBlockProps;
  banner: BannerProps;
  article: ArticleProps;
  rentACarReview: RentACarReview;
  reviewsConst: ReviewsConst;
  reviews: Reviews;
};

export const AvisRentACar: NextPage<AvisRentACarProps> = ({
  layout,
  heroBlock,
  banner,
  article,
  rentACarReview,
  reviewsConst,
  reviews,
}: AvisRentACarProps) => {
  const intl = useIntl();

  return (
    <Layout
      layout={layout}
      defaultCanonicalRoute={routes.avisRentACar}
      title={intl.formatMessage({ id: "avisRentACar" })}
      breadcrumbs={[
        { title: intl.formatMessage({ id: "home" }), url: "/" },
        {
          title: intl.formatMessage({ id: `avisRentACar` }),
          url: routes.avisRentACar,
        },
      ]}
    >
      <HeroBlock {...heroBlock} />
      <Banner containerStyle={styles.banner} {...banner} />
      <Section>
        <Article containerStyle={styles.article} {...article} />
      </Section>
      <ReviewsBlock
        title={intl.formatMessage({ id: "avisRentACarReviewsTitle" })}
        rentACarReview={rentACarReview}
        reviewsConst={reviewsConst}
      />
      <Section containerStyle={styles.reviews}>
        <AllReviews reviewsInit={reviews} />
      </Section>
    </Layout>
  );
};
